export const ts = {
  PASS_MODAL_GUEST_INFO_HEADING: {
    description: 'Guest Info',
    primaryValue: 'Guest Info',
    stringKey: 'PASS_MODAL_GUEST_INFO_HEADING',
  },
  PASS_MODAL_GUEST_INFO_HEADING_SELF_INVITE: {
    description: 'My Info',
    primaryValue: 'My Info',
    stringKey: 'PASS_MODAL_GUEST_INFO_HEADING_SELF_INVITE',
  },
  PLACEHOLDER_FIRST_NAME: {
    description: 'First Name',
    primaryValue: 'First Name',
    stringKey: 'PLACEHOLDER_FIRST_NAME',
  },
  PLACEHOLDER_LAST_NAME: {
    description: 'Last Name',
    primaryValue: 'Last Name',
    stringKey: 'PLACEHOLDER_LAST_NAME',
  },
  PLACEHOLDER_EMAIL_ADDRESS: {
    description: 'Email Address',
    primaryValue: 'Email Address',
    stringKey: 'PLACEHOLDER_EMAIL_ADDRESS',
  },
  PASS_MODAL_EMAIL_CONFIRMATION: {
    description: 'Email Confirmation',
    primaryValue: 'Email Confirmation',
    stringKey: 'PASS_MODAL_EMAIL_CONFIRMATION',
  },
  PASS_MODAL_MEMBERSHIP: {
    description:
      'Prompt for the email address field on the add/edit pass modal when the pass policy requires a guest who is registered as a Nike+ member',
    primaryValue: 'Guest must be a registered Nike⁠+ member:',
    stringKey: 'PASS_MODAL_MEMBERSHIP',
  },
  PASS_MODAL_MEMBERSHIP_LEARN_MORE: {
    description: 'Learn More link on Guest Membership email field.',
    primaryValue: 'Learn More',
    stringKey: 'PASS_MODAL_MEMBERSHIP_LEARN_MORE',
  },
  PASS_MODAL_EMAIL_ERROR: {
    description: 'Invalid email format error message',
    primaryValue: 'Please enter a valid email address',
    stringKey: 'PASS_MODAL_EMAIL_ERROR',
  },
  PASS_MODAL_NOEMAILOPTIN: {
    description: 'No Email Opt-In',
    primaryValue: 'No Email Opt-In',
    stringKey: 'PASS_MODAL_NOEMAILOPTIN',
  },
  PLACEHOLDER_GUEST_MEMBERSHIP: {
    description: 'Placeholder text for email field for passes requiring Nike+ Membership',
    primaryValue: 'Nike⁠+ Member Email Address',
    stringKey: 'PLACEHOLDER_GUEST_MEMBERSHIP',
  },
  PLACEHOLDER_MY_EMAIL: {
    description: 'My email address',
    primaryValue: 'My Email',
    stringKey: 'PLACEHOLDER_MY_EMAIL',
  },
  PLACEHOLDER_GUEST_EMAIL: {
    description: 'Guest Email',
    primaryValue: 'Guest Email',
    stringKey: 'PLACEHOLDER_GUEST_EMAIL',
  },
  PASS_MODAL_STORE_HEADING: {
    description: 'Store',
    primaryValue: 'Store',
    stringKey: 'PASS_MODAL_STORE_HEADING',
  },
  HEADER_BAR_LANGUAGE: {
    description: 'Label for language selection dropdown in header',
    primaryValue: 'Language:',
    stringKey: 'HEADER_BAR_LANGUAGE',
  },
  DDL_STORE_SELECT: {
    description: 'Select Store',
    primaryValue: 'Select Store',
    stringKey: 'DDL_STORE_SELECT',
  },
  SHOPPING_TIME_HEADING: {
    description: 'Reserve',
    primaryValue: 'Reserve',
    stringKey: 'SHOPPING_TIME_HEADING',
  },
  DDL_SHOPPING_TIME_SELECT: {
    description: 'Select',
    primaryValue: 'Select',
    stringKey: 'GRID_HEADER_SELECT',
  },
  PASS_MODAL_REGISTER_CHECK_IN: {
    description: 'Register & Check In',
    primaryValue: 'Register & Check In',
    stringKey: 'PASS_MODAL_REGISTER_CHECK_IN',
  },
  SAVING_TEXT: {
    description: 'Saving...',
    primaryValue: 'Saving...',
    stringKey: 'SAVING_TEXT',
  },
  PASS_MODAL_UPDATE: {
    description: 'Update',
    primaryValue: 'Update',
    stringKey: 'PASS_MODAL_UPDATE',
  },
  PASS_MODAL_REGISTER: {
    description: 'Register',
    primaryValue: 'Register',
    stringKey: 'PASS_MODAL_REGISTER',
  },
  LEARN_MORE_INTRO: {
    description: 'Intro sentence for the Membership Learn More popover',
    primaryValue:
      'Your single Nike⁠+ account connects you to all the Nike⁠+ apps and Nike.com. With Nike⁠+ you get:',
    stringKey: 'LEARN_MORE_INTRO',
  },
  LEARN_MORE_SHIPPING: {
    description: 'Membership Learn More Popover shipping benefits',
    primaryValue: 'Free shipping. You read that right. Free, every time.',
    stringKey: 'LEARN_MORE_SHIPPING',
  },
  LEARN_MORE_TRIALS: {
    description: 'Membership Learn More Popover trial benefits',
    primaryValue:
      "30-day trials. Try out a product for 30 days. If you don't like it, return it – no questions asked.",
    stringKey: 'LEARN_MORE_TRIALS',
  },
  LEARN_MORE_RETURNS: {
    description: 'Membership Benefits Popover return benefits',
    primaryValue:
      "Easy, receipt-free returns. Because you've got enough to keep track of and remember.",
    stringKey: 'LEARN_MORE_RETURNS',
  },
  LEARN_MORE_LINK: {
    description: 'Membership Learn More Popover sign up link prompt.',
    primaryValue: 'Your guest can sign up for Nike⁠+ using this link:',
    stringKey: 'LEARN_MORE_LINK',
  },
  GOVT_COMPLIANCE_HONGKONG: {
    description: 'Hong Kong Government Compliance',
    primaryValue:
      'I acknowledge and confirm that the recipient and user of the pass requested is not a government official, an employee of state-owned entity, an official of any political party or candidate for political office except where such a government official is an immediate family member*. I acknowledge having read and understood the <a target="blank" class="greenText" href="https://niketech.service-now.com/nikehr?id=nikehr_kb_article_view&sysparm_article=KB0031894&sys_kb_id=4e3aa90edb5c8950aa5fa47813961971&spa=1">Gifts and Hospitality Policy.</a><br/>*Immediate family member shall mean spouse, sibling, parents or child of the employees.',
    stringKey: 'GOVT_COMPLIANCE_HONGKONG',
  },
  GOVT_COMPLIANCE_TAIWAN: {
    description: 'Taiwan Government Compliance',
    primaryValue:
      'I acknowledge and confirm that the recipient and user of the pass requested is not a government official, an employee of state-owned entity, an official of any political party or candidate for political office except where such a government official is an immediate family member*. I acknowledge having read and understood the <a target="blank" class="greenText" href="https://niketech.service-now.com/nikehr?id=nikehr_kb_article_view&sysparm_article=KB0031894&sys_kb_id=4e3aa90edb5c8950aa5fa47813961971&spa=1">Gifts and Hospitality Policy.</a><br/>*Immediate family member shall mean spouse, sibling, parents or child of the employees.',
    stringKey: 'GOVT_COMPLIANCE_TAIWAN',
  },
  GOVT_COMPLIANCE_CHINA: {
    description: 'China Government Compliance',
    primaryValue:
      'I acknowledge and confirm that the recipient and user of the pass requested is not a government official, an employee of state-owned entity, an official of any political party or candidate for political office except where such a government official is an immediate family member*. I acknowledge having read and understood the <a target="blank" class="greenText" href="https://niketech.service-now.com/nikehr?id=nikehr_kb_article_view&sysparm_article=KB0031894&sys_kb_id=4e3aa90edb5c8950aa5fa47813961971&spa=1">Gifts and Hospitality Policy</a> and <a target="blank" class="greenText" href="https://niketech.service-now.com/nikehr?id=nikehr_kb_article_view&sysparm_article=KB0040754">Nike Product Policy.</a><br/>*Immediate family member shall mean spouse, sibling, parents or child of the employees.',
    stringKey: 'GOVT_COMPLIANCE_CHINA',
  },
  TOASTR_PASS_ADDED: {
    description: '{{passType}} pass added',
    primaryValue: '{{passType}} pass added',
    stringKey: 'TOASTR_PASS_ADDED',
  },
  TOASTR_CHANGES_SAVED: {
    description: 'Changes Saved',
    primaryValue: 'Changes Saved',
    stringKey: 'TOASTR_CHANGES_SAVED',
  },
  TOASTR_PASS_ERROR: {
    description: 'There was an error adding your pass.',
    primaryValue: 'There was an error adding your pass.',
    stringKey: 'TOASTR_PASS_ERROR',
  },
  DDL_NO_SHOPPING_TIME: {
    description: 'No Shopping Times Available',
    primaryValue: 'No Shopping Times Available',
    stringKey: 'DDL_NO_SHOPPING_TIME',
  },
  PASS_MODAL_AVAILABLE: {
    description: 'Available',
    primaryValue: '{{remaining}} of {{total}} Available',
    stringKey: 'PASS_MODAL_AVAILABLE',
  },
};
